export default __webpack_public_path__ + "static/media/role.75039327.svg";